import OptionFilter from "./OptionFilter";

export default class DirectorsFilter extends OptionFilter {
	static option_selector_id = "directors-filter";

	static shouldBeInitialized(): boolean {
		return document.getElementById(this.option_selector_id) != null;
	}

	shouldShow(gridItem: HTMLElement): boolean {
		return this.shouldShowWithData(DirectorsFilter.option_selector_id, gridItem.dataset.directors);
	}
}
